import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { UsersMfaCollection } from './users-mfa.types';

export function usersMfaBackend(): Backend<UsersMfaCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    // FIXME: T50039 This endpoint doesn't appear to be ordered in the backend
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/self',
      params: {
        mfa_details: true,
      },
    }),
    push: undefined,
    set: undefined,
    update: (authUid, delta, original) => {
      if (!delta.mfa) {
        throw new Error('Nothing to be updated.');
      }

      return {
        endpoint: 'users/0.1/self/account',
        method: 'PUT',
        payload: {
          mfa_preferences: {
            preferred_method: delta.mfa.preferredMethod,
          },
        },
      };
    },
    remove: undefined,
  };
}
